export const refLayersToInclude = [
  {
    layer: "Paddlesports",
    overrideTitle: "Intensity (low to high)",
    tooltip:
      "Mapped intensity values of paddle sport activities (i.e. non-motorized water sports such as stand-up paddleboarding and kayaking) based on TripAdvisor and Flickr photos and TripAdvisor reviews, buffered out from the attraction locations; values are unitless and expressed from high to low values.",
    measurement: "Intensity (low to high)",
  },
  {
    layer: "Seafood Restaurants",
    overrideTitle: "Concentration (low to high)",
    tooltip:
      "Mapped concentration values of seafood restaurants and other attractions serving fresh fish based on TripAdvisor reviews, with values buffered out to reduce errors of locational accuracy; values are unitless and expressed from high to low values.",
    measurement: "Concentration (low to high)",
  },
  {
    layer: "Population Analysis - Number of People",
    title: "Number of People per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 332,
        visible: false,
      },
      {
        id: 333,
        visible: false,
      },
      {
        id: 334,
        visible: false,
      },
      {
        id: 335,
        visible: true,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Women",
    title: "Number of Women per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 332,
        visible: false,
      },
      {
        id: 333,
        visible: false,
      },
      {
        id: 334,
        visible: true,
      },
      {
        id: 335,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Elderly",
    title: "Number of Elderly (over 60 years old) per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 332,
        visible: false,
      },
      {
        id: 333,
        visible: true,
      },
      {
        id: 334,
        visible: false,
      },
      {
        id: 335,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Children",
    title: "Number of Children (under 5 years old) per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 332,
        visible: true,
      },
      {
        id: 333,
        visible: false,
      },
      {
        id: 334,
        visible: false,
      },
      {
        id: 335,
        visible: false,
      },
    ],
    isRaster: true,
  },
];

export const Beaches = {
  stats: {
    large: [
      {
        name: "Expenditures (USD)",
        title:
          "Estimated expenditure from Beaches linked to Natural Values (US$)",
        tooltip:
          "Mapped estimates of the annual dollar expenditure of which can be assigned to natural elements of the beach to the tourism sector. Natural importance was assigned based on the numbers and locations of photos with visual signatures of natural value (e.g., clear water, white sand, vegetation and forested hills). Values are expressed in $USD.",
        measurement: "($USD)",
      },
      {
        name: "Total visitation value (number of people)",
        title: "Total Visitation Value",
        tooltip:
          "Mapped estimates of the annual visitor numbers who are present due to the natural values of the beach. Natural importance was assigned based on the numbers and locations of photos with visual signatures of natural value (e.g., clear water, white sand, vegetation and forested hills). Values are expressed in visitor numbers/ha, representing the additionality of tourists who are present in the country because of these natural values.",
        measurement: "",
      },
      {
        name: "Highest value beaches (top 10%) generate (USD)",
        title: "Highest Value Tourist Beaches",
        tooltip:
          "Map highlighting the beaches estimated to have the highest annual dollar values in the region.  This map depicts the 10% of beach areas (top decile)with the highest values in red, and the remainder of the reefs in gray.",
        measurement: "($USD)",
      },
    ],
    small: [
      {
        name: "Total beach area (sqkm)",
        title: "Total Beach Area",
        tooltip:
          "Beach area derived from beach habitat data layer digitized by TNC from satellite imagery. Polygons were converted to a 100m grid to capture the broader area over which beach-related activities are expected to occur, and area estimates are based on the 100m raster layer.",
        measurement: "(sqkm)",
      },
      {
        name: "Beaches used for tourism (sqkm, %)",
        title: "Beaches Used for Nature-Dependent Tourism",
        tooltip:
          "Includes any 100m grid cell of reef habitat with that had a modelled expenditures or visitation value.",
        measurement: "",
      },
    ],
  },
  data: [
    {
      name: "CROP Countries",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/4",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/2",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/3",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/0",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/5",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_04282021_WFL1/FeatureServer/1",
        },
        {
          name: "Statistics Table",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOWCROP_AppStats_05042021/FeatureServer/0",
        },
      ],
    },
    {
      name: "Dominica",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/15",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/0",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/10",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/5",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/25",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/20",
        },
      ],
    },
    {
      name: "Grenada",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/16",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/1",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/11",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/6",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/26",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/21",
        },
      ],
    },
    {
      name: "Saint Kitts and Nevis",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/17",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/2",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/12",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/7",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/27",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/22",
        },
      ],
    },
    {
      name: "Saint Lucia",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/18",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/3",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/13",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/8",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/28",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/23",
        },
      ],
    },
    {
      name: "Saint Vincent and the Grenadines",
      layers: [
        {
          name: "Modelled visitation value of nature-dependent beach tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/19",
        },
        {
          name: "Estimated expenditure from beaches linked to natural values (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/4",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/14",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/9",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/29",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Nature_Dependent_Beaches_Scaled_per_Country_WFL1/FeatureServer/24",
        },
      ],
    },
  ],
};

export const ReferenceConfig = [
  {
    url: "https://oceanwealth.org/wp-content/uploads/2021/05/Output_4_Coral_Reef_Tourism_Report_Final_20201130REDUCED.pdf",
    label: "Technical Report",
  },
  {
    url: "https://oceanwealth.org/wp-content/uploads/2021/06/Nature_Dependent-Beaches-Technical-Summary.pdf",
    label: "Technical Summary",
  },
  {
    url: "https://tnc.box.com/shared/static/i2rpvan5ees56chcipnutul4elfknatz.zip",
    label: "Data Download",
  },
  {
    url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
    label: "Country Summary",
  },
];
